import { ReactComponent as ReportIcon } from '@svgs/report.svg';
import { ReactComponent as SidePanelOpenIcon } from '@svgs/side-panel.svg';
import { ReactComponent as SidePanelClosedIcon } from '@svgs/side-panel-closed.svg';
import { ReactComponent as TextIcon } from '@svgs/text.svg';

export const buttonLayoutByVariant = {
  report: {
    svg: ReportIcon,
  },
  sidePanelClosed: {
    svg: SidePanelClosedIcon,
  },
  sidePanelOpen: {
    svg: SidePanelOpenIcon,
  },
  text: {
    svg: TextIcon,
  },
};
